import { render, staticRenderFns } from "./Login_old.vue?vue&type=template&id=3b019507&scoped=true&"
import script from "./Login_old.vue?vue&type=script&lang=js&"
export * from "./Login_old.vue?vue&type=script&lang=js&"
import style0 from "./Login_old.vue?vue&type=style&index=0&id=3b019507&lang=less&scoped=true&"
import style1 from "./Login_old.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b019507",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b019507')) {
      api.createRecord('3b019507', component.options)
    } else {
      api.reload('3b019507', component.options)
    }
    module.hot.accept("./Login_old.vue?vue&type=template&id=3b019507&scoped=true&", function () {
      api.rerender('3b019507', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Login_old.vue"
export default component.exports